import React, { useEffect } from 'react'

// styles
import { MainContainer } from '../About/about.style'

// components
import Heading from '../../components/Heading/Heading'
import { Column } from './booking.style'

const Booking = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://link.msgsndr.com/js/form_embed.js'
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <MainContainer>
      <Heading title='Book Now' />
      <Column>
        <iframe
          src="https://api.leadconnectorhq.com/widget/form/fZCes9IKOW5RDTyqHHVR"
          style={{ width: '100%', height: '100%', border: 'none', borderRadius: '3px' }}
          id="inline-fZCes9IKOW5RDTyqHHVR"
          data-layout="{'id':'INLINE'}"
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="Opt In Form"
          data-height="805"
          data-layout-iframe-id="inline-fZCes9IKOW5RDTyqHHVR"
          data-form-id="fZCes9IKOW5RDTyqHHVR"
          title="Opt In Form"
        />
      </Column>
    </MainContainer>
  )
}

export default Booking
